module.exports = new __parcel__URL__("eye-in-the-sky.b804cb5d.jpg").toString();